import React, { useState, useEffect, Fragment, useCallback } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { PrimaryButton, AddButton } from '../../components/Buttons';
import appConfig from '../../../app-config';
import {
  getProductItemCount,
  getComboItemCount,
} from './utils/displayOptionsItems';
import { isProductOrComboDisabled } from './utils/handleCompareProducts';
import { Headline, Caption1 } from '../../components/Typography';
const OrderWrapper = styled.div`
  margin-right: 10px;
  margin-top: ${(props) => (props.isCategory ? '0' : '48px')};
  border: 1px solid ${(props) => props.theme.orderAgainBorderColor};
  border-radius: 12px;
  width: 500px;
  height: 170px;
  @media only screen and (max-width: 480px) {
    max-width: 385px;
  }
`;
const AddAllButton = styled(PrimaryButton)`
  border: 2px solid ${(props) => props.theme.orderAgainButtonBorderColor};
  height: 36px;
  font-size: 14px;
  box-shadow: none;
  border-radius: ${(props) => props.theme.addAllOrdersButtonRadius};
  background: ${(props) => props.theme.orderAgainTitleButtonBackgroundColor};
  color: ${(props) => props.theme.orderAgainTitleButtonFontColor};
  font-weight: 600;
  &:hover {
    background: ${(props) =>
      props.theme.orderAgainTitleButtonBackgroundColorHover};
    border: 0;
    color: ${(props) => props.theme.orderAgainTitleButtonTextColorHover};
    transition: all 0.25s ease;
  }
`;
const DateAndAddAll = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  background: ${(props) => props.theme.orderAgainTitleBackgroundColor};
  border-radius: 8px;
  height: 51px;
  padding: 0 20px;

  @media (max-width: 768px) {
    grid-template-columns: auto 100px;
  }
`;

const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.isNoImage ? null : '70px auto')};
  grid-gap: 5px;
  padding: 5px 15px;
  align-items: center;
  &:hover {
    transition: all 0.25s ease;
  }

  @media (max-width: 768px) {
    grid-template-columns: 56px auto;
    grid-gap: 5px;
  }
`;

const ProductImage = styled.img`
  height: ${(props) => props.sizes || '70px'};
  width: ${(props) => props.sizes || '70px'};
  object-fit: cover;
  border-radius: 50%;
  border: ${(props) => props.theme.orderHistoryProductImageBorder};
  color: ${(props) => (props.isAvailable ? 'inherit' : props.theme.gray)};
  filter: ${(props) => (props.isAvailable ? null : 'grayscale(0.9)')};
  @media (max-width: 768px) {
    height: ${(props) => props.sizes || '56px'};
    width: ${(props) => props.sizes || '56px'};
  }
`;

const ViewAll = styled.div`
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  align-self: center;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
`;

const NonProductImage = styled.div``;

const ProductInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 73px;
  grid-gap: 5px;
  align-items: center;
  @media (max-width: 400px) {
    max-width: 280px;
  }
`;

const ProductInfo = styled.div``;

const ProductName = styled(Headline)`
  color: ${(props) =>
    props.isAvailable
      ? props.theme.black
      : props.theme.unavailableProductColor};
  text-transform: capitalize;
`;

const ProductDescription = styled(Caption1)`
  color: ${(props) =>
    props.isAvailable
      ? props.theme.darkGray
      : props.theme.unavailableProductColor};
  @media (max-width: 768px) {
    // display: none;
  }
`;
const CardTitle = styled(Headline)`
  color: ${(props) => props.theme.orderAgainTitleFontColor};
`;
const PriceAndAdd = styled.div``;
const MoreItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  align-items: center;
  margin: 0 20px 10px 30px;
`;

const MoreItemsSection = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
`;
const MoreItemsIconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  --gap: -16px;
  margin-left: calc(-1 * var(--gap));
  margin-right: 5px;
  img {
    margin-left: var(--gap);
  }
`;
const ViewAllWrapper = styled.div`
  grid-column: 2;
  cursor: pointer;
  font-weight: 500;
  i {
    margin-left: 3px;
    font-size: 12px;
  }
`;
const MoreItems = styled.div`
  width: 100%;
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
const LocationWrapper = styled.span`
  font-size: 14px;
  font-weight: normal;
`;

const OrderHistoryItem = ({
  order,
  products,
  combos,
  addPastOrderToCart,
  editPreviousProductConfiguration,
  handleOpenHistoryModal,
  selectedLocation,
  locations,
}) => {
  const [remainedItems, setRemainedItems] = useState();
  const [pastOrderedProducts, setPastOrderedProducts] = useState([]);
  const [pastOrderdCombos, setPastOrderdCombos] = useState([]);
  const [businessName, setBusinessName] = useState('');
  useEffect(() => {
    if (locations?.length > 0) {
      const orderedbussinessName = locations.find(
        (location) => location.id === order.business_id
      )?.name;
      if (orderedbussinessName) setBusinessName(orderedbussinessName);
    }
  }, [locations]);
  useEffect(() => {
    let productList = [];
    let comboList = [];
    if (order.products?.length > 0) {
      productList.push(order.products[0]);
      setPastOrderedProducts(productList);
    }
    if (order.combos?.length > 0) {
      comboList.push(order?.combos[0]);
      setPastOrderdCombos(comboList);
    }
    const totalItemsNumber = order.products.length + order.combos.length;
    if (totalItemsNumber > 1) {
      setRemainedItems(totalItemsNumber - 1);
    } else {
      setRemainedItems();
    }
  }, [order]);
  return (
    <Fragment>
      <OrderWrapper>
        <DateAndAddAll>
          <CardTitle>
            {moment(order.order_date).format('MMM. DD')} -{' '}
            <LocationWrapper>{businessName}</LocationWrapper>
          </CardTitle>
          {(pastOrderedProducts?.length || pastOrderdCombos?.length) && (
            <AddAllButton
              small
              onClick={() =>
                addPastOrderToCart(order.products, order.combos, null)
              }
            >
              Reorder
            </AddAllButton>
          )}
        </DateAndAddAll>
        {pastOrderdCombos?.length > 0 &&
          pastOrderdCombos.map((comboOrder) => (
            <ProductWrapper
              isNoImage={appConfig.isNoImage}
              isAvailable={comboOrder?.combo_availability[0].is_available}
            >
              {!appConfig.isNoImage && (
                <ProductImage
                  isAvailable={
                    !isProductOrComboDisabled(combos, comboOrder, 'combo')
                  }
                  src={comboOrder?.image_url}
                />
              )}
              <NonProductImage>
                <ProductInfoWrapper>
                  <ProductInfo>
                    <ProductName
                      isAvailable={
                        !isProductOrComboDisabled(combos, comboOrder, 'combo')
                      }
                    >
                      {comboOrder?.name.length > 10
                        ? `${comboOrder?.name.toLowerCase().substr(0, 10)}...`
                        : comboOrder?.name?.toLowerCase()}
                      {comboOrder?.quantity > 1 && ` x${comboOrder?.quantity}`}
                    </ProductName>
                    {getComboItemCount(comboOrder?.combo_item_groups) > 0 && (
                      <ProductDescription
                        isAvailable={
                          comboOrder?.combo_availability[0].is_available
                        }
                      >
                        <p style={{ fontSize: '14px' }}>
                          {getComboItemCount(comboOrder.combo_item_groups)}{' '}
                          customization
                        </p>
                      </ProductDescription>
                    )}
                  </ProductInfo>
                  <PriceAndAdd>
                    {!isProductOrComboDisabled(combos, comboOrder, 'combo') && (
                      <AddButton
                        onClick={(e) => {
                          e.stopPropagation();
                          addPastOrderToCart(null, comboOrder, true);
                        }}
                      />
                    )}
                  </PriceAndAdd>
                </ProductInfoWrapper>
              </NonProductImage>
            </ProductWrapper>
          ))}
        {pastOrderedProducts?.length > 0 &&
          pastOrderdCombos?.length === 0 &&
          pastOrderedProducts.map((productOrder) => (
            <ProductWrapper
              isNoImage={appConfig.isNoImage}
              isAvailable={productOrder?.is_product_available}
              aria-disabled={true}
            >
              {!appConfig.isNoImage && (
                <ProductImage
                  isAvailable={
                    !isProductOrComboDisabled(products, productOrder, 'product')
                  }
                  src={productOrder.image_url}
                />
              )}
              <NonProductImage>
                <ProductInfoWrapper>
                  <ProductInfo>
                    <ProductName
                      isAvailable={
                        !isProductOrComboDisabled(
                          products,
                          productOrder,
                          'product'
                        )
                      }
                    >
                      {productOrder?.name.length > 10
                        ? `${productOrder?.name.toLowerCase().substr(0, 15)}...`
                        : productOrder?.name?.toLowerCase()}
                      {productOrder?.quantity > 1 &&
                        ` x${productOrder?.quantity}`}
                    </ProductName>
                    {productOrder?.options && (
                      <ProductDescription
                        isAvailable={
                          !isProductOrComboDisabled(
                            products,
                            productOrder,
                            'product'
                          )
                        }
                      >
                        <p style={{ fontSize: '14px' }}>
                          {productOrder?.prices[0]?.name}
                          {' / '}
                          {getProductItemCount(productOrder?.options)}{' '}
                          customization
                        </p>
                      </ProductDescription>
                    )}
                  </ProductInfo>
                  <PriceAndAdd>
                    {!isProductOrComboDisabled(
                      products,
                      productOrder,
                      'product'
                    ) && (
                      <AddButton
                        onClick={(e) => {
                          e.stopPropagation();
                          addPastOrderToCart(productOrder, null, true);
                        }}
                      />
                    )}
                  </PriceAndAdd>
                </ProductInfoWrapper>
              </NonProductImage>
            </ProductWrapper>
          ))}
        <MoreItemsWrapper>
          {remainedItems && (
            <MoreItemsSection>
              <MoreItemsIconWrapper>
                {order.products
                  .slice(1, order.products.length)
                  .map((product) => (
                    <ProductImage
                      isAvailable={product?.is_product_available}
                      src={product.image_url}
                      sizes='28px'
                    />
                  ))}
              </MoreItemsIconWrapper>
              <MoreItems>+ {remainedItems} more items</MoreItems>
            </MoreItemsSection>
          )}
          <ViewAllWrapper
            onClick={() =>
              handleOpenHistoryModal(order.products, order.combos, order)
            }
          >
            View <i className='fa fa-chevron-right'></i>
          </ViewAllWrapper>
        </MoreItemsWrapper>
      </OrderWrapper>
    </Fragment>
  );
};

export default OrderHistoryItem;
